var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 29,
    viewBox: "0 0 41 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 370",
    d: "M33.0452 9.94192C34.0507 7.51606 35.4649 5.28065 37.2262 3.33292C37.5167 3.0069 37.6926 2.59474 37.7269 2.15939C37.7612 1.72404 37.6521 1.28942 37.4162 0.921918C37.2384 0.63768 36.9907 0.403771 36.6968 0.242531C36.4028 0.0812915 36.0724 -0.00189472 35.7372 0.000918062C35.5443 -0.00551493 35.3517 0.0218992 35.1682 0.0819179C31.1892 1.24692 21.8852 5.37792 21.6262 18.6229C21.5478 21.048 22.3755 23.4154 23.948 25.2633C25.5204 27.1112 27.7248 28.3072 30.1312 28.6179C31.456 28.7584 32.7955 28.6185 34.0627 28.2073C35.3298 27.796 36.4963 27.1228 37.4861 26.2312C38.476 25.3396 39.2672 24.2496 39.8082 23.0322C40.3491 21.8148 40.6279 20.4971 40.6262 19.1649C40.6287 16.9864 39.8734 14.8748 38.4897 13.1921C37.106 11.5094 35.1802 10.3604 33.0422 9.94192H33.0452Z",
    fill: "#008755"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 371",
    d: "M8.51791 28.6179C9.84182 28.7569 11.1802 28.6159 12.446 28.204C13.7119 27.792 14.8769 27.1185 15.8655 26.227C16.8541 25.3356 17.6442 24.2461 18.1843 23.0294C18.7245 21.8128 19.0027 20.4961 19.0009 19.1649C19.0034 16.9864 18.2481 14.8748 16.8644 13.1921C15.4807 11.5094 13.5549 10.3604 11.4169 9.94192C12.4237 7.51579 13.8392 5.28037 15.6019 3.33292C15.8925 3.0069 16.0683 2.59474 16.1026 2.15939C16.1369 1.72404 16.0278 1.28942 15.7919 0.921918C15.6141 0.63768 15.3664 0.403771 15.0725 0.242531C14.7785 0.0812915 14.4482 -0.00189472 14.1129 0.000918062C13.92 -0.00551493 13.7274 0.0218992 13.5439 0.0819179C9.56191 1.24692 0.257907 5.38192 0.000906787 18.6229V18.8129C-0.0317505 21.2084 0.818692 23.5321 2.38996 25.3405C3.96124 27.149 6.14334 28.3157 8.51991 28.6179H8.51791Z",
    fill: "#008755"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotations);
export default __webpack_public_path__ + "static/media/quotations.faa284c5fec328a631475122334ef08f.svg";
export { ForwardRef as ReactComponent };